export type PinItemType = "task" | "note";

const PIN_KEY_PREFIX = "calcera:pins";

function getStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function storageKey(userId: string | undefined, itemType: PinItemType): string {
  const owner = userId && userId.trim() ? userId.trim() : "anonymous";
  return `${PIN_KEY_PREFIX}:${owner}:${itemType}`;
}

export function loadPinnedIds(userId: string | undefined, itemType: PinItemType): Set<string> {
  const store = getStorage();
  if (!store) return new Set();
  try {
    const raw = store.getItem(storageKey(userId, itemType));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    const clean = parsed
      .map((v) => (typeof v === "string" ? v.trim() : ""))
      .filter((v) => v.length > 0);
    return new Set(clean);
  } catch {
    return new Set();
  }
}

function savePinnedIds(userId: string | undefined, itemType: PinItemType, ids: Set<string>): void {
  const store = getStorage();
  if (!store) return;
  try {
    const arr = Array.from(ids);
    store.setItem(storageKey(userId, itemType), JSON.stringify(arr));
  } catch {
    // ignore storage failures
  }
}

export function setPinned(
  userId: string | undefined,
  itemType: PinItemType,
  id: string,
  pinned: boolean,
): Set<string> {
  const current = loadPinnedIds(userId, itemType);
  const next = new Set(current);
  if (pinned) {
    next.add(id);
  } else {
    next.delete(id);
  }
  savePinnedIds(userId, itemType, next);
  return next;
}

export function isPinned(
  pinnedIds: Set<string>,
  id: string | null | undefined,
): boolean {
  if (!id) return false;
  return pinnedIds.has(id);
}


